module.exports = __webpack_public_path__ + "img/Stahlzaun_1.a3d71893.jpg";